import { useQuery } from "urql";

import {
  CollateralFilter,
  CollateralOrderBy,
  GetCollateralsBuyerNumberDocument,
} from "../../../graphql/generated.ts";
import { ApiHookProps } from "../types.ts";

export const useCollateralsBuyerNumber = ({
  filter,
  orderBy,
  pause,
}: ApiHookProps<CollateralFilter, CollateralOrderBy>) => {
  const variables = { filter, orderBy };
  return useQuery({
    query: GetCollateralsBuyerNumberDocument,
    variables,
    pause,
  });
};
